import {Heading, Item, Picker, View} from "@adobe/react-spectrum";
import {memo, useEffect} from "react";
import {getSearchParam, setSearchParam} from "../../utils/url_search";
import {AnalysisEntity, PickerOption, SearchParam} from "../../types";
import {SpectrumPickerProps} from "@react-types/select";

export const entities: Array<PickerOption> = Object.values(AnalysisEntity)
    .map((entity) => ({
        id: entity,
        name: entity,
    }));

export type AnalysisEntityPickerOnChange = (interval: AnalysisEntity) => void

export interface IntervalPickerProps extends Omit<SpectrumPickerProps<PickerOption>, "children"> {
    searchParamName?: SearchParam,
    onChange: AnalysisEntityPickerOnChange
    value: AnalysisEntity,
}

function isValidOption(value: string): value is AnalysisEntity {
    const optionNames: Set<string> = new Set(Object.values(AnalysisEntity));
    return optionNames.has(value);
}

function AnalysisEntityPicker({
                            onChange,
                            searchParamName = SearchParam.AnalysisEntity,
                            label = "Entity",
                            value,
                            ...props
                        }: IntervalPickerProps) {

    useEffect(() => {
        const optionString = getSearchParam(searchParamName);
        if (
            (optionString !== null)
            && isValidOption(optionString)
        ) {
            onChange(optionString)
        } else {
            setSearchParam(searchParamName, AnalysisEntity.Leads)
        }
    }, [
        onChange,
        searchParamName,
    ])

    const id = `entityPicker${label}`;

    return (
        <View>
            <Heading
                id={id}
                level={4}
            >
                {label}
            </Heading>
            <Picker
                aria-labelledby={id}
                items={entities}
                selectedKey={value}
                onSelectionChange={(value) => {
                    const interval = value as AnalysisEntity;
                    onChange(interval);
                    setSearchParam(searchParamName, interval)
                }}
                {...props}
            >
                {(item) => <Item>{item.name}</Item>}
            </Picker>
        </View>
    )
}

export default memo(AnalysisEntityPicker);
